import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformResponseHandler } from 'utils/transformResponseHandler';

export const manageAccountsApi = createApi({
    reducerPath: 'manageAccountsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_API_ROUTE}/pos`,
        prepareHeaders: (headers, { getState }) => {
            const token = getState()?.posData?.token;
            if (token) {
                headers.set('Authorization', token);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getStaffsList: builder.query({
            query: ({ page, limit, search, role = "all" }) => {
                return {
                    url: `/staff`,
                    method: 'GET',
                    params: {
                        page: page,
                        perPage: limit,
                        search: search ?? "",
                        role: role
                    },
                }
            },
            providesTags: ['staffList'],
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        addStaffs: builder.mutation({
            query: (body) => ({
                url: '/staff',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['staffList'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        updateStaffs: builder.mutation({
            query: ({ id, ...body }) => ({
                url: `/staff/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['staffList'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        deleteStaffs: builder.mutation({
            query: (id) => ({
                url: `/staff/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['staffList'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        changeStaffStatus: builder.mutation({
            query: ({ id, body }) => ({
                url: `/staff/change-status/${id}`,
                method: 'PUT',
                body: { status: body },
            }),
            invalidatesTags: ['staffList'],
            transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
        getAvailableRiders: builder.query({
            query: () => ({
                url: '/staff/available-riders',
                method: 'GET',
            }),
            // transformResponse: (resp) => transformResponseHandler(resp),
            transformErrorResponse: (error) => transformResponseHandler(error)
        }),
    }),
});

export const {
    useGetStaffsListQuery,
    useAddStaffsMutation,
    useUpdateStaffsMutation,
    useDeleteStaffsMutation,
    useChangeStaffStatusMutation,
    useGetAvailableRidersQuery
} = manageAccountsApi;
